import axios from "axios";
import { Markup } from "interweave";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import CricketBanner from "../../../../../../assets/images/LearningSession/liveSessionBanner.png";
import AllModuleData from "../../../../../Reuseable/AllModuleData";
import LoaderPost from "../../../../../Reuseable/LoaderPost";
import "./AdminLearningMain.css";
import LearningSessionResult from "./LearningSessionResult";
import LearningSessionResultTable from "./LearningSessionResultTable";

const AdminLearningMain = () => {
  const [event_data, setEvents] = useState([]);
  const [count, setCount] = useState([]);
  const [buffer, setBuffer] = useState(true);

  // Fetch Approved LiveChat
  useEffect(() => {
    axios.get(`/api/admin/learning_session/result`).then((res) => {
      setBuffer(false);
      if (res.status === 200) {
        
        setEvents(res.data.event);
        setCount(res.data.count);
      }
    });
  }, []);

  return (
    <>
      <div
        title="Live Now"
        className="col-md-3 align-items-center justify-content-center "
      >
        <div className="card card-bg nav-body-dashboard mb-3">
          <div className="card-body  align-items-center">
            <center>
              <tr>
                <td className="livechat-card-td">
                  <i className="fa-solid fa-square-poll-vertical iconResultStyle"></i>
                </td>
                <td className="livechat-card-td">
                  <small className="p-3 fw-bold rounded-1 text-warning textFontResult">
                    {count}
                  </small>
                </td>
              </tr>
            </center>
          </div>
          <Link
            // to="/superstar-admin/learning-session/completed"
            className="card-footer livechat-card-footer"
          >
            <button
              className="livechat-card-footer"
              data-bs-toggle="collapse"
              data-bs-target="#collapseOne"
              aria-expanded="true"
              aria-controls="collapseOne"
            >
              Result
            </button>
          </Link>
        </div>
      </div>

      <div className="card card-bg head-line mt-4 mb-2 mt-4 mb-2">
        <div className="text-light d-flex p-2">
          <div className="faTrophy">
            <i className="fas fa-trophy"></i>
          </div>
          <h4 className="mx-3 text-white p-2">Learning Session Result</h4>
        </div>
      </div>
      {buffer ? <LoaderPost /> : <LearningSessionResult data={event_data} />}
    </>
  );
};

export default AdminLearningMain;
